import useDefinedContext from "hooks/useDefinedContext";
import RemoteConfigContext from "../RemoteConfigContext";

function useRemoteConfig(key: string) {
  return useDefinedContext(RemoteConfigContext)(key);
}

export default useRemoteConfig;
